export const SINGLE_SIGN_ON_TEST_IDS = {
  defaultFirmRoleSelect: 'firm-single-sign-on__default-firm-role-select',
  emailDomainsInput: 'firm-single-sign-on__associated-email-domains-input',
  emailDomainsSection: 'firm-single-sign-on__associated-email-domains-section',
  enforcedSsoCheckbox: 'firm-single-sign-on__enforced-sso-checkbox',
  entityIdCopyAction: 'firm-single-sign-on__entity-id-copy-action',
  entityIdValue: 'firm-single-sign-on__entity-id-value',
  jitProvisioningCheckbox: 'firm-single-sign-on__jit-provisioning-checkbox',
  metadataUrlInput: 'firm-single-sign-on__metadata-url-input',
  serviceProviderMetadataSection: 'firm-single-sign-on__service-provider-metadata-section',
  settingsSection: 'firm-single-sign-on__settings-section',
  acsUrlCopyAction: 'firm-single-sign-on__acs-url-copy-action',
  acsUrlValue: 'firm-single-sign-on__acs-url-value',
} as const;
